import moment from 'moment';

import { comparisonColors } from '../../utils/colors';
import { displayShortDate } from '../../utils/Format/Format';

export const historicalPricesChartCardUtil = (gqlResult, filter = []) => {
    if (!gqlResult) return null;
    const {
        mutualFund: { priceHistory, name }
    } = gqlResult;

    const colors = comparisonColors;

    const data =
        priceHistory &&
        priceHistory.length &&
        priceHistory
            .map((ele) => ({
                label: displayShortDate(ele.asOfDate),
                headers: [name],
                data: [ele.price]
            }))
            .filter(
                (elem) =>
                    elem.data[0] > 0 &&
                    ((filter[0] && filter[0].count <= 0) ||
                        moment(
                            moment().subtract(filter[0].count, 'months'),
                            'MM/DD/YYYY'
                        ).isBefore(moment(elem.label, 'MM/DD/YYYY')))
            );

    return { colors, data };
};
